/*
===============================================================================================================
                                 Copyright 2022-2023, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import { ALLOWED_CSV_FILE_TYPES } from './csv-validation';

const getAcceptedFilesList = (fileType) => {
  switch (fileType) {
    case 'csv':
      return ALLOWED_CSV_FILE_TYPES;
    default:
      return undefined;
  }
};

export default getAcceptedFilesList;
